export const BACKEND_URL = "https://varotravam-backend-production.up.railway.app";
// export const BACKEND_URL = "http://localhost:8080";
 
// https://varotravam-bg2xwzuf.b4a.run
// https://varotravam-backend-production.up.railway.app
// http://localhost:8080
// psychotic-move-production.up.railway.app
//